var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ApiGetSpaces } from '@/infrastructure/api-functions/api-spaces';
import { SpaceType, SpaceUserRole } from '../enums';
import _ from 'lodash';
import { DateFormatter } from '@/infrastructure/utils/date-formatter.interface';
let PaginatedSpacesRepositoryImpl = class PaginatedSpacesRepositoryImpl {
    constructor(_apiGetSpaces, _dateFormatter) {
        this._apiGetSpaces = _apiGetSpaces;
        this._dateFormatter = _dateFormatter;
    }
    async query(data) {
        const request = {
            sort_type: data.sortBy,
            type: data.spaceType,
            label_name: data.labelName,
            page: data.page,
            limit: data.pageSize,
            can_access_public_space: true,
        };
        const response = await this._apiGetSpaces.getSpaces(request);
        const spaces = response.records.map(record => this._formatSpace(record));
        const totalPage = Math.ceil(response.total / response.limit);
        const result = {
            data: spaces,
            total: response.total,
            page: response.page,
            pageSize: response.limit,
            totalPage,
            totalWithoutFilter: response.total,
        };
        return result;
    }
    _formatUser(user) {
        if (!user) {
            return null;
        }
        return {
            userId: user.user_id,
            companyId: user.company_id,
            companyName: user.company_name,
            email: user.email,
            mobileNumber: user.mobile_number,
            nickname: user.nickname,
        };
    }
    _formatSpace(record) {
        const userRole = _.toLower(record.user_role);
        const space = {
            spaceId: record.space_id,
            spaceName: record.space_name,
            spaceType: this._getSpaceType(record),
            lastVisitTime: this._dateFormatter.format(record.latest_access_ts),
            folderCount: record.normal_folder_count + (record.auto_folder_count || 0),
            buildInIconId: record.space_icon,
            iconImageUrl: record.space_s3_key,
            isShared: record.is_shared_space,
            isPublic: record.is_public_space,
            permission: {
                share: record.permission_detail?.share,
            },
            tags: record.label_ids,
            isManager: userRole === SpaceUserRole.Manage,
            sharedCount: record.shared_count,
            createTime: this._dateFormatter.format(record.created_at),
            updateTime: this._dateFormatter.format(record.update_ts),
            topSpace: record.top_space,
            userRole: _.toLower(record.user_role),
            updatedUser: this._formatUser(record.update_user_info),
            creator: this._formatUser(record.owner),
            patentCount: record.total_patent_count,
            paperCount: record.total_paper_count,
            bioCount: record.total_bio_count,
            drugCount: record.total_drug_count,
            clinicalCount: record.total_clinical_count,
            investmentCount: record.total_vc_count,
            marketCount: record.total_mr_count,
            mergerCount: record.total_ma_count,
        };
        return space;
    }
    _getSpaceType(type) {
        if (type.is_shared_space) {
            return SpaceType.Shared;
        }
        if (type.is_public_space) {
            return SpaceType.Public;
        }
        return SpaceType.Personal;
    }
};
PaginatedSpacesRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ApiGetSpaces)),
    __param(1, inject(DateFormatter)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiGetSpaces !== "undefined" && ApiGetSpaces) === "function" ? _a : Object, typeof (_b = typeof DateFormatter !== "undefined" && DateFormatter) === "function" ? _b : Object])
], PaginatedSpacesRepositoryImpl);
export { PaginatedSpacesRepositoryImpl };
